import { lang as enLang } from "./en";
import { lang as bnLang } from "./bn";

export const languages = {
  en: enLang,
  bn: bnLang,
};
